import React, { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import Card from "react-bootstrap/Card";
import TrackImage from '~/Components/Elements/Global/TrackImage';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ItemTypes = {
    CARD: 'card',
}

const style = {
    marginBottom: '.6rem',
    backgroundColor: 'white',
    cursor: 'move',
}

export const DraggableCard = ({ id, index, moveCard, track, playlistId, hasDropped, handleDeleteClick, showAddedBy, ownerDir }) => {
    const ref = useRef(null)
    const [, drop] = useDrop({
        accept: ItemTypes.CARD,
        drop(_item, monitor) {
            hasDropped();
            return;
        },
        hover(item, monitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = item.index
            const hoverIndex = index

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }

            // Determine rectangle on screen
            const hoverBoundingRect = ref.current.getBoundingClientRect()

            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

            // Determine mouse position
            const clientOffset = monitor.getClientOffset()

            // Get pixels to the top
            const hoverClientY = (clientOffset).y - hoverBoundingRect.top

            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%

            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }

            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }

            // Time to actually perform the action
            moveCard(dragIndex, hoverIndex)

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    })

    const [{ isDragging }, drag] = useDrag({
        item: { type: ItemTypes.CARD, id, index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    const opacity = isDragging ? 0 : 1
    drag(drop(ref))
    return (
        <div ref={ref} style={{ ...style, opacity }}>
            <Card body className="m-3 text-left">
                <div className="trackDelete" onClick={() => handleDeleteClick(track.id)}>
                    <FontAwesomeIcon icon={faTimes} style={{ fontSize: 22 }} />
                </div>
                <TrackImage styles={{ marginRight: 20 }} width={`100px`} track={track} /> "{track.title}" by {track.artist}
                {showAddedBy && track.addedByName && track.addedBy !== ownerDir && (
                  <div className="addedBy">
                    Added by {track.addedByName}
                    {Number(track.addedByIsChim) === 1 ? " Chimney" : ""}
                  </div>
                )}
            </Card>
        </div>
    )
}